<template>
	<div class="wrapper1200" style="display: flex;margin-top: 20px;">
		<div class="classification">
			<div class="singleType" :class="typeIndex==0?'active':''" @click="jumpTo">病例信息</div>
			<div class="singleType" :class="typeIndex==1?'active':''" @click="jumpTo">历史病例</div>
		</div>
		<div class="diagnosis">
			<div class="heartache">
				<div>病例信息</div>
				<div>></div>
				<div>历史病例</div>
				<div> ></div>
				<div>病例详情</div>
			</div>
			<div class="addTo">
				<div class="title">病例详情</div>
				<div class="howManyInARow">
					<div class="single">
						<div class="medicalConsultation">就诊号</div>
						<div class="inputBox">
							{{no==''?'无':no}}
							<!-- <input type="text" placeholder="请输入就诊号" v-model="no" /> -->
						</div>
					</div>
					<div class="single">
						<div class="medicalConsultation">就诊时间</div>
						<div class="inputBox">
							{{caseTime==''?'无':caseTime}}
						</div>
					</div>
				</div>
				<div class="howManyInARow">
					<div class="single">
						<div class="medicalConsultation">科室</div>
						<div class="inputBox">
							{{subject==''?'无':subject}}
							<!-- <input type="text" placeholder="请输入科室" v-model="subject" /> -->
						</div>
					</div>
					<div class="single">
						<div class="medicalConsultation">身高</div>
						<div class="inputBox">
							{{height==''?'无':height}}
							<!-- <input type="text" placeholder="请输入身高" v-model="height" /> -->
						</div>
					</div>
				</div>
				<div class="howManyInARow">
					<div class="single">
						<div class="medicalConsultation">体重</div>
						<div class="inputBox">
							{{weight==''?'无':weight}}
							<!-- <input type="text" placeholder="请输入体重" v-model="weight" /> -->
						</div>
					</div>
					<div class="single">
						<div class="medicalConsultation">辅助检查</div>
						<div class="inputBox">
							{{assist==''?'无':assist}}
							<!-- <input type="text" placeholder="请输入辅助检查" v-model="assist" /> -->
						</div>
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">主诉</div>
					<div class="chiefComplaintInput">
						{{suit==''?'无':suit}}
						<!-- <input type="text" placeholder="请输入主诉内容" v-model="suit" /> -->
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">现病史</div>
					<div class="chiefComplaintInput">
						{{historyOfPresentIllness==''?'无':historyOfPresentIllness}}
						<!-- <input type="text" placeholder="请输入现病史内容" v-model="historyOfPresentIllness" /> -->
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">既往史和其他病史</div>
					<div class="chiefComplaintInput">
						{{medicalHistory==''?'无':medicalHistory}}
						<!-- <input type="text" placeholder="请输入既往史和其他病史内容" v-model="medicalHistory" /> -->
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">过敏史(食物或者药品)</div>
					<div class="chiefComplaintInput">
						{{allergy==''?'无':allergy}}
						<!-- <input type="text" placeholder="请输入过敏史(食物或者药品)内容" v-model="allergy" /> -->
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">诊断</div>
					<div class="chiefComplaintInput">
						{{diagnose==''?'无':diagnose}}
						<!-- <input type="text" placeholder="请输入诊断内容" v-model="diagnose" /> -->
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">处理</div>
					<div class="chiefComplaintInput">
						{{dispose==''?'无':dispose}}
						<!-- <input type="text" placeholder="请输入处理内容" v-model="dispose" /> -->
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">病情评估</div>
					<div class="chiefComplaintInput">
						{{assess==''?'无':assess}}
						<!-- <input type="text" placeholder="请输入病情评估内容" v-model="assess" /> -->
					</div>
				</div>
				<div class="indiChiefComplaint">
					<div class="vidual">治疗意见</div>
					<div class="chiefComplaintInput">
						{{opinion==''?'无':opinion}}
						<!-- <input type="text" placeholder="请输入治疗意见内容" v-model="opinion" /> -->
					</div>
				</div>
				<div class="caseImages">
					<div class="titleImage">上传病例图片</div>
					<div class="uploadImage">
						<img :src="img" alt="" v-if="img!=''" />
						<div v-else>无</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		caseDetails
	} from "@/api/api.js"
	import {
		baseURL
	} from "@/api/index";
	export default {
		data() {
			return {
				action: baseURL + "/common/upload",
				token: localStorage.getItem('token'),
				typeIndex: 1,
				no: "",
				caseTime: '',
				subject: '',
				height: '',
				weight: '',
				assist: '',
				suit: '',
				historyOfPresentIllness: '',
				medicalHistory: '',
				allergy: '',
				diagnose: '',
				dispose: '',
				assess: '',
				opinion: '',
				img: '',
				caseReportId: ''
			}
		},
		mounted() {
			this.caseReportId = this.$route.query.id
			this.clickOnDetails()
		},
		methods: {
			//详情
			clickOnDetails() {
				caseDetails({
					caseReportId: this.caseReportId
				}).then(res => {
					if (res.code == 200) {
						this.no = res.data.no
						this.caseTime = res.data.caseTime
						this.subject = res.data.subject
						this.height = res.data.height
						this.weight = res.data.weight
						this.assist = res.data.assist
						this.suit = res.data.suit
						this.historyOfPresentIllness = res.data.historyOfPresentIllness
						this.medicalHistory = res.data.medicalHistory
						this.allergy = res.data.allergy
						this.diagnose = res.data.diagnose
						this.dispose = res.data.dispose
						this.assess = res.data.assess
						this.opinion = res.data.opinion
						this.img = res.data.img
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			jumpTo() {
				this.$router.push({
					path: '/caseInformation'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-upload-list__item-status-label {
		display: none !important;
	}

	::v-deep .el-upload-list--picture-card {
		display: flex;
		width: 330px;
	}

	::v-deep .el-upload--picture-card {
		width: 42.5px;
		height: 42.5px;
		line-height: normal;
		border: none;
	}

	::v-deep .el-upload-list--picture-card .el-upload-list__item {
		width: 42.5px;
		height: 42.5px;
	}

	.classification {
		.singleType {
			width: 202px;
			height: 50px;
			background: #F1F1F1;
			border-radius: 0px 0px 0px 0px;
			line-height: 50px;
			padding-left: 18px;
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 15px;
			color: #333333;
		}

		.active {
			background: #D89A3A;
			color: #fff;
		}
	}

	.diagnosis {
		margin-left: 20px;
		padding-bottom: 132px;
		// position: relative;
		flex: 1;
		cursor: default;

		.heartache {
			display: flex;
			align-items: center;

			div {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #666666;
				margin-right: 10px;
			}




		}

	}

	.addTo {
		background: #FFFFFF;
		padding: 30px 100px;
		margin-top: 20px;

		.title {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: bold;
			font-size: 22px;
			color: #333333;
			text-align: center;
			margin-bottom: 30px;
		}

		.howManyInARow {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.single {
				display: flex;
				align-items: center;
				border-bottom: 1px solid #E6E6E6;
				padding: 15px 0;
				width: 45%;

				.medicalConsultation {
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					font-size: 14px;
					color: #333333;
					width: 56px;
				}

				.inputBox {
					border: none;
					outline: none;
					box-shadow: none;
					margin-left: 40px;

					input {
						border: none;
						outline: none;
						box-shadow: none;
					}
				}
			}
		}

	}

	.indiChiefComplaint {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #E6E6E6;
		padding: 15px 0;

		.vidual {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 14px;
			color: #333333;
		}

		.chiefComplaintInput {
			margin-left: 54px;
			flex: 1;

			input {
				width: 100%;
				border: none;
				outline: none;
				box-shadow: none;
			}
		}
	}

	.caseImages {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px 0;
		border-bottom: 1px solid #E6E6E6;

		.titleImage {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #333333;
		}

		.uploadImage {
			// flex: 1;
			// margin-left: 40px;

			img {
				width: 42.5px;
				height: 42.5px;
			}
		}

	}

	.saveButton {
		width: 661px;
		height: 50px;
		background: linear-gradient(90deg, #ECBF85 0%, #D89A3A 100%);
		border-radius: 30px 30px 30px 30px;
		font-family: PingFang SC, PingFang SC;
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
		text-align: center;
		line-height: 50px;
		margin: 0 auto;
		margin-top: 60px;
	}
</style>